var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPresent({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "14px",
    viewBox: "0 0 16 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon/Display") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon/Display",
    transform: "translate(-3.000000, -2.000000)",
    stroke: "#B7844D"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.004576, 3.003014)",
    id: "Icon/Media-Library"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000, -0.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Stroke-3",
    strokeWidth: 1.3,
    points: "0 9.99698621 13.9951302 9.99698621 13.9951302 0 0 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Stroke-2",
    strokeWidth: 1.142,
    fill: "#B7844D",
    transform: "translate(6.992460, 9.249436) rotate(270.000000) translate(-6.992460, -9.249436) ",
    points: "9.69660042 9.34405726 4.28832042 13.5062159 4.38235317 4.99265586"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPresent);
export default __webpack_public_path__ + "static/media/Present.3337de3fe6a44ff133e6e982d5cf8e9d.svg";
export { ForwardRef as ReactComponent };